export default __webpack_public_path__ + "static/find-section-02add1ae041954e5a924d5f45e61ea88.png";